var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-module",attrs:{"id":"activityModuleCoupon"}},[_c('div',{attrs:{"id":"activityModuleTask"}},[_c('CouponModule',{staticClass:"coupon-tab",attrs:{"slot":"coupon"},slot:"coupon"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }